import { InfoColoredIcon } from '@carboncopyco/icons';
import { ImportEditsIllustration } from '@carboncopyco/illustrations';
import { ColorHex, LoadingDots, Paper, TextMenuHeader } from '@carboncopyco/ui';
import { useImportManagerState } from '../ImportManagerContext';
import { EmptyState } from './EmptyState';
import { ModificationCategory } from './ModificationCategory';

export const ModificationsPanel = () => {
  const { selectedDemoId, modificationCategories, isFetchingModifications } =
    useImportManagerState();

  const demoHasNoModifications =
    selectedDemoId && !modificationCategories?.length;
  const showCategories =
    selectedDemoId &&
    !isFetchingModifications &&
    !!modificationCategories?.length;

  return (
    <Paper
      radius
      border="ds-regular"
    >
      <div className="h-full bg-ds-natural-50 rounded-lg">
        <div className="w-[380px] flex flex-col h-full">
          <div className="flex flex-col p-5 h-full">
            <TextMenuHeader label="edit types" />
            {!selectedDemoId ? (
              <EmptyState
                illustration={<ImportEditsIllustration />}
                label="Select a demo to view the available edits"
              />
            ) : isFetchingModifications ? (
              <div className="flex items-center justify-center h-full w-full">
                <LoadingDots />
              </div>
            ) : showCategories ? (
              <ul className="flex flex-col gap-3 mt-3">
                {modificationCategories?.map(
                  ({ categoryId, count, schemaTypes, relatedSchemas }) => (
                    <ModificationCategory
                      key={categoryId}
                      categoryId={categoryId}
                      schemaTypes={schemaTypes}
                      count={count}
                      relatedSchemas={relatedSchemas}
                    />
                  )
                )}
              </ul>
            ) : (
              demoHasNoModifications && (
                <EmptyState
                  illustration={<InfoColoredIcon color={ColorHex.primary300} />}
                  label="No edits in this demo"
                />
              )
            )}
          </div>
        </div>
      </div>
    </Paper>
  );
};
